<template>
    <v-app id="searchMlhf">
        <v-main v-if="!loading">
            <v-container fluid>  
                <v-card>
                    <v-card-title class="justify-center">Email headers and footers</v-card-title>
                    <v-simple-table dense>
                        <tbody v-for="(mlhfGrpRecord, i) in mhlfs" :key="i">
                            <tr>
                                <td>{{ mlhfGrpRecord.mlhf_nr }}</td>
                                <td>{{ mlhfGrpRecord.mlhf_oms }}</td>
                                <td v-for="(mlhfRecord,j) in mlhfGrpRecord.mlhf" :key="j" @click="$router.reload('/syst/mltp/onMlhf2/' + mlhfRecord.mlhf_encrid)"><a>{{ mlhfRecord.mlhf_id }}</a></td>
                            </tr>  
                        </tbody>  
                    </v-simple-table>  
                </v-card>  
            </v-container>
        </v-main>
        <navBar title="Ares - Mail templates" :home="true" type="mltp"/>
    </v-app>
</template>
 
<script>
    import navBar from "@/components/ui/navbars/navbar.vue"
 
    export default {
        components: {
            navBar
        },
        data() {
            return {
                loading: true,
                mhlfs: []
            }  
        },
  
        mounted() {
            this.searchMlhf();
        },
        methods: {
            searchMlhf() {
                this.$axios.post("ares/json/ares/syst/mltp/searchMlhf.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchMlhf"
                    },
                    searchMlhf: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.mhlfs = res.data.searchMlhf;
                        this.loading = false;
                    }
                });
            },
            actionClick() {
            },
        },
    };
</script> 
